export default __webpack_public_path__ + "static/media/farmerWoman.4a1e2db6.png";